import script from "./ResultNotfound.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultNotfound.vue?vue&type=script&setup=true&lang=js"

import "./ResultNotfound.vue?vue&type=style&index=0&id=0aa875ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa875ca"]])

export default __exports__